import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { State } from 'state';
import { isLoggedIn } from 'state/selectors/user';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { ExternalLinkItem } from './external-link-item';

const mapStateToProps = (state: State) => {
	return {
		isLoggedIn: isLoggedIn(state),
	};
};
export default injectIntl(
	withAnalyticsContext({
		component: 'externalResourceItem',
	})(connect(mapStateToProps)(ExternalLinkItem)),
);
